/**
 * DOMPurify's default `ALLOWED_URI_REGEXP` plus a
 * `data:image/<raster>;base64,` alternative. Mirrors the upstream
 * default exactly so a library version bump can't silently widen the
 * surface — only the final alternation adds the data-URI allowance,
 * scoped to raster MIME types.
 *
 * svg+xml is intentionally excluded: an inline SVG can carry
 * `<script>` and arbitrary JS in event-handler attributes, which
 * DOMPurify cannot recursively re-sanitize once it's a base64 blob.
 * Other `data:` MIME types (text/html, application/javascript) stay
 * blocked for the same reason.
 *
 * Required because the BE `/generate-image` handler emits
 * `![…](data:image/png;base64,…)` and DOMPurify's default config
 * strips the `data:` src, leaving the chat bubble showing only the
 * alt text bracket form.
 */
export const SAFE_URI_REGEXP =
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix|skype|bitcoin|bitcoincash|geo|maps):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$)|data:image\/(?:png|jpe?g|gif|webp);base64,)/i;
